export default {
  title: {
    id: 'popular_search_title',
    defaultMessage: 'Popular searches',
  },
}
